module.exports = __webpack_public_path__ + "static/media/contact-landing.28489229.jpg";